import React, { useEffect, useRef, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { validDateDetails } from "../../services/vehicleService";
import { toast } from "react-toastify";
import ConfimationModal from "../modals/ConfirmationModal";
import "./TripDetailForm.css";
import { DateRange } from "@mui/icons-material";
import imageCompression from "browser-image-compression";

const TripDetailsForm = ({
  formFields,
  prefilled,
  formSubmitted,
  setFormSubmitted,
  exportData,
  setErrors,
  index,
  exportAddition,
  resetTrigger,
  editData,
  btnText,
  exportBlur,
}) => {
  const [formData, setFormData] = useState({});
  const [validateField, setValidateField] = useState(null);

  const [errorObj, setErrorObj] = useState(null);
  const [refresh, setRefresh] = useState(false);

  const [maxHard, setMaxhard] = useState(0);
  const [maxSoft, setMaxSoft] = useState(0);
  const [showModal, setShowModal] = useState(false);

  const [onFoc, setOnFoc] = useState(false);

  const [lessThan, setLessThan] = useState("");
  const [greatThan, setGreatThan] = useState("");
  const [validateRes, setValidateRes] = useState(null);

  const [blurFields, setBlurFields] = useState([
    { name: "tripHard", value: "hardCubicMeter" },
    { name: "tripSoft", value: "softCubicMeter" },
    // { name: "hourReading", value: "hourReading" },
  ]);

  const [maxArray, setMaxArray] = useState([]);

  const [validateread, setValidateRead] = useState([]);

  const [shiftStatus, setShiftStatus] = useState(null);

  const [checkFields, setCheckFields] = useState(["kmOpening", "startReading"]);

  const [maxFuel, setMaxFuel] = useState();
  const [maxTrips, setMaxTripKmReading] = useState();

  const sortedFields = formFields?.sort((a, b) => a.sequence - b.sequence);

  const [otherFields, setOtherFields] = useState(
    sortedFields.filter((f) => f.fieldType !== "prefill")
  );
  const [prefillFields, setPrefillFields] = useState(
    sortedFields.filter((f) => f.fieldType === "prefill")
  );
  // const prefillFields = sortedFields.filter((f) => f.fieldType === "prefill");
  // const otherFields = sortedFields.filter((f) => f.fieldType !== "prefill");

  const fieldsRequried = formFields?.filter(
    (f) => f.fieldType !== "prefill" || f.isRequired == 1
  );

  const maxFields = formFields?.filter((f) => {
    return f.fieldType != "prefill" || f.maxInput != null;
  });

  const [requiredFields, setRequiredFields] = useState(fieldsRequried);

  useEffect(() => {
    console.log(formFields);
    setOtherFields(sortedFields.filter((f) => f.fieldType !== "prefill"));
    setPrefillFields(sortedFields.filter((f) => f.fieldType === "prefill"));

    const fieldsRequried = formFields.filter(
      (f) => f.fieldType !== "prefill" || f.isRequired == 1
    );
    setRequiredFields(fieldsRequried);

    // const [requiredFields, setRequiredFields] = useState(fieldsRequried);
  }, [formFields]);

  const handleChange = (e, field) => {
    const { name, value } = e.target;
    // // console.log(name, value);
    if (value && field) {
      delete errorObj?.[field.fieldValue];
    }
    if (shiftStatus == 2) {
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
    // // console.log(formData);
  };

  const handleDropdown = (value, name) => {
    if (value) {
      delete errorObj?.[name];
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleChange2 = (name, value) => {
    if (value) {
      delete errorObj?.[name];
    }
    if (shiftStatus == 2) {
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
    // console.log(formData);
  };

  useEffect(() => {
    setShiftStatus(null);
    if (prefilled) {
      console.log(prefilled);
      setShiftStatus(prefilled.shiftStatus);

      if (prefilled.shiftStatus == 2) {
        if (!toast.isActive("sdfsdfsdfsdfsdfsd")) {
          toast.warn(
            "Previous shift for this vehicle is not closed " +
              prefilled["registrationNumber"],
            {
              toastId: "sdfsdfsdfsdfsdfsd", // Ensures this toast doesn't appear multiple times
            }
          );
        }
      }

      if (prefilled.status == 2) {
        if (!toast.isActive("sdfsdfsdfsdfsdfsd")) {
          toast.warn(
            "This Vehicle is under Maintenance " +
              prefilled["registrationNumber"],
            {
              toastId: "sdfsdfsdfsdfsdfsd", // Ensures this toast doesn't appear multiple times
            }
          );
        }
      }
      // // console.log(prefilled);
      let obj = {
        venderName: "",
        vehicleNumber: "",
        vehicleName: "",
      };
      console.log(prefilled);
      prefillFields.forEach((element) => {
        // // console.log(element);
        if (element) {
          console.log(element);

          obj[element.fieldValue] = prefilled[element.fieldValue];

          // formData[element.fieldValue] = prefilled[element.fieldValue]
          obj["venderName"] = prefilled?.vendor?.name
            ? prefilled?.vendor?.name
            : prefilled.vendorName;
          obj["vehicleNumber"] = prefilled?.registrationNumber
            ? prefilled?.registrationNumber
            : prefilled.vehicleNumber;
          obj["vehicleName"] = prefilled?.make
            ? prefilled?.make
            : prefilled.vehicleName;
        }
      });
      setFormData(obj);

      // // console.log(otherFields);
    }

    if (editData) {
      let obj = editData;
      setFormData((prev) => ({
        ...prev,
        ...obj,
      }));
      // console.log(formData);
      if (obj?.fuelTypestate) {
        handleChange2("fuelTypestate", obj?.fuelTypestate);
      }

      [otherFields[0] + "id"].current;
    }
  }, [prefilled, refresh, resetTrigger, formFields, editData]);

  // useEffect(() => {
  //   // // console.log(editData);
  //   // if (editData) {
  //   //   let obj = editData;
  //   //   // // console.log(obj);
  //   //   setFormData(obj);
  //   //   if (obj?.fuelTypestate) {
  //   //     handleChange2("fuelTypestate", obj?.fuelTypestate);
  //   //   }
  //   // }
  // }, [editData]);
  useEffect(() => {
    if (formSubmitted) {
      exportData(formData, index);
    }
  }, [formSubmitted]);

  useEffect(() => {
    if (formData?.kmOpening && formData?.kmClosing) {
      const start = parseFloat(formData["kmOpening"]);
      const end = parseFloat(formData["kmClosing"]);
      if (!isNaN(start) && !isNaN(end)) {
        const diff = end - start;
        // // console.log(diff);
        setFormData((prev) => ({
          ...prev,
          kmCovered: diff >= 0 ? diff.toFixed(2) : "",
        }));
      } else {
        setFormData((prev) => ({ ...prev, kmCovered: "" }));
      }
    }
  }, [formData?.kmOpening, formData?.kmClosing]);

  useEffect(() => {
    if (formData?.tripHard && formData?.tripSoft) {
      const start = parseFloat(formData["tripHard"]);
      const end = parseFloat(formData["tripSoft"]);
      if (!isNaN(start) && !isNaN(end)) {
        const diff = end - start;
        // // console.log(diff);
        setFormData((prev) => ({
          ...prev,
          tripsCount: start + end,
        }));
      } else {
        setFormData((prev) => ({ ...prev, tripsCount: 0 }));
      }
    }
  }, [formData?.tripSoft, formData?.tripHard]);

  useEffect(() => {
    if (formData?.startReading && formData?.endReading) {
      const start = parseFloat(formData["startReading"]);
      const end = parseFloat(formData["endReading"]);
      if (!isNaN(start) && !isNaN(end)) {
        const diff = end - start;
        setFormData((prev) => ({
          ...prev,
          workingHours: diff >= 0 ? diff.toFixed(2) : "",
        }));
      } else {
        setFormData((prev) => ({ ...prev, workingHours: "" }));
      }
    }
  }, [formData?.startReading, formData?.endReading]);

  useEffect(() => {
    if (formData?.quantity && formData?.fuelRate) {
      const start = parseFloat(formData["quantity"]);
      const end = parseFloat(formData["fuelRate"]);
      if (!isNaN(start) && !isNaN(end)) {
        setFormData((prev) => ({
          ...prev,
          totalAmount: formData?.quantity * formData?.fuelRate,
        }));
      } else {
        setFormData((prev) => ({ ...prev, totalAmount: "" }));
      }
    }
  }, [formData?.quantity, formData?.fuelRate]);

  const firstInputRef = useRef(null);

  // useEffect(() => {
  //   if (firstInputRef?.current) {
  //     firstInputRef.current.focus();
  //   }
  // }, [firstInputRef]);

  const handleSubmit = (e) => {
    e.preventDefault();
    // // console.log("Form submitted:", formData);
    alert("Form submitted!");
  };

  const handleChange1 = (e, field) => {
    let errors = validateFieldsMax(e.target.value, field);
    console.log(errors);

    if (shiftStatus == 1 || shiftStatus == null) {
      if (
        (field.fieldType == "number" || field.fieldType == "tel") &&
        isNaN(e?.target?.value) &&
        e?.target?.value?.length > 10
      ) {
        return;
      }

      if (
        field?.maxValue &&
        (field?.fieldValue == "softCubicMeter" ||
          field?.fieldValue == "hardCubicMeter")
      ) {
        if (e.target.value <= field?.maxValue) {
          handleChange(e, field);
        }
      } else {
        if (field.fieldType == "number" || field.fieldType == "tel") {
          console.log(e.target.value);
          if (e?.target?.value?.length < 10) {
            handleChange(e);
          }
        } else {
          handleChange(e);
        }
      }
    } else if (shiftStatus == 2) {
      if (!toast.isActive("sdfsdfsdfsdfsdfsd")) {
        toast.warn(
          "Previous shift for this vehicle is not closed " +
            prefilled["registrationNumber"],
          {
            toastId: "sdfsdfsdfsdfsdfsd", // Ensures this toast doesn't appear multiple times
          }
        );
      }
    }
  };

  const handleCompression = async (files) => {
    const options = {
      maxSizeMB: 1, // max size in MB
      maxWidthOrHeight: 1024, // resize if larger
      useWebWorker: true,
    };
    console.log(files);
    const compressedList = await Promise.all(
      files.map(async (file) => {
        const compressed = await imageCompression(file, options);
        return new File([compressed], file.name, {
          type: compressed.type,
        });
      })
    );
    console.log(compressedList);
    return compressedList;
  };

  const renderTextField = (field) => {
    if (!field) {
      return;
    }

    const nameKey = field.fieldName.replace(/\s+/g, "");
    const isReadOnly =
      field.fieldType === "prefill" || field.fieldType === "autofill";
    const value =
      field.fieldType === "prefill" || field.fieldType === "autofill"
        ? field.value || ""
        : formData[nameKey] || "";

    if (
      field.fieldType == "text" ||
      field.fieldType == "autofill" ||
      field.fieldType == "prefill" ||
      field.fieldType == "number" ||
      field.fieldType == "tel"
    ) {
      return (
        <div className="col-md-3 mt-2 mb-3 divs_textfield" key={field.id}>
          <TextField
            fullWidth
            label={field?.fieldName}
            name={field?.fieldValue}
            // ref={field?.fieldValue + "id"}
            InputLabelProps={{
              shrink: true,
            }}
            sx={{
              "& label.Mui-focused": {
                color: "grey",
              },
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": {
                  borderColor: "#ffd700",
                },
              },
            }}
            disabled={shiftStatus == 2 || prefilled.status == 2}
            value={formData?.[field.fieldValue]}
            onChange={(e) => {
              setOnFoc(false);
              console.log(shiftStatus);
              if (shiftStatus == 2) {
                if (!toast.isActive("sdfsdfsdfsdfsdfsd")) {
                  toast.warn(
                    "Previous shift for this vehicle is not closed " +
                      prefilled["registrationNumber"],
                    {
                      toastId: "sdfsdfsdfsdfsdfsd", // Ensures this toast doesn't appear multiple times
                    }
                  );
                }
                return;
              } else {
                handleChange1(e, field);
              }
            }}
            title={
              shiftStatus == 2 &&
              "Previous shift for this vehicle is not closed " +
                prefilled["registrationNumber"]
            }
            // id={field.fieldValue + `id`}
            InputProps={{
              readOnly: isReadOnly,
              style: { fontSize: "small" },
            }}
            type={
              field.fieldType == "number" || field.fieldType == "tel"
                ? "number"
                : "text"
            }
            required={field.isRequired === 1}
            variant="outlined"
            size="small"
            placeholder={`Enter ${field.fieldName}...`}
            FormHelperTextProps={{
              sx: { fontSize: "xx-small" },
            }}
            onBlur={(e) => {
              validateFieldsMax(e.target.value, field);
              let obj = blurFields.find((x) => {
                return x.name == field.fieldValue;
              });
              if (formData?.["hourReading"] || formData?.["kmReading"]) {
                exportBlur(formData, prefilled);
              }
              // // console.log(obj);
              if (obj) {
                let maxTripCubicMter = formData[field.fieldValue] * 14;
                if (obj) {
                  formData[obj.value] = maxTripCubicMter;
                }
                // // console.log(field.fieldValue);
                let arr = otherFields.map((x) => {
                  if (x?.fieldValue == obj.value) {
                    // if (editData == null) {
                    //   formData[obj.value] = null;
                    // }

                    return {
                      ...x,
                      fieldType: "autofill",
                      maxValue: maxTripCubicMter,
                    };
                  } else {
                    return { ...x };
                  }
                });
                setOtherFields(arr);
              }

              // // console.log(checkFields.includes(field.fieldValue));
              if (
                (checkFields.includes(field.fieldValue) &&
                  field.fieldValue.includes("km") &&
                  !formData?.["reasonKm"]) ||
                (field.fieldValue.includes("start") &&
                  checkFields.includes(field.fieldValue) &&
                  !formData?.["reasonHour"])
              ) {
                validateTripDetails(field);
                // // console.log("sdfshdfsdfgvsdvfsd");
              }
            }}
            error={
              (errorObj?.[field.fieldValue] && !formData?.[field.fieldValue]) ||
              (field.maxInput &&
                maxArray.find((x) => x.fieldValue == field.fieldValue))
            }
            helperText={
              (errorObj?.[field.fieldValue] && !formData?.[field.fieldValue]) ||
              (field.maxInput &&
                maxArray.find((x) => x.fieldValue == field.fieldValue) && (
                  <span className="text-danger">{`${field.fieldName} can't be more than ${field.maxInput}`}</span>
                ))

              // `${field?.fieldName} is required`
            }
          />
        </div>
      );
    } else if (field.fieldType == "dropdown") {
      return (
        <div className="col-md-3 mt-1 mb-3" key={field.id}>
          <Autocomplete
            options={field?.list || []}
            size="small"
            className="inp_search"
            // sx={{ width: 300 }}
            value={formData[field.fieldValue + "state"] || null}
            style={{ padding: "2px", fontSize: "10px" }}
            getOptionLabel={(option) => option?.[field.showValue] || ""}
            onChange={(e, newValue, reason) => {
              if (reason == "clear") {
                setFormData((prev) => ({
                  ...prev,
                  [`${field.fieldValue}state`]: null,
                }));
              }

              // // console.log(newValue);

              if (newValue) {
                setFormData((prev) => ({
                  ...prev,
                  [`${field.fieldValue}state`]: newValue,
                  [`${field.fieldValue}`]: newValue[field.sentValue],
                }));
                // handleDropdown(`${field.fieldValue} + state`, newValue);
                // handleChange2(field.fieldValue, newValue[field.sentValue]);
                // handleChange2(field.fieldValue, newValue[field.sentValue]);

                handleChange2("fuelRate", newValue["fuelRate"]);
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={`Search ${field.fieldName}`}
                error={
                  errorObj?.[field.fieldValue] && !formData?.[field.fieldValue]
                }
                InputLabelProps={{
                  style: { fontSize: "12px" }, // Change label font size
                }}
                disabled={shiftStatus == 2 || prefilled.status == 2}
                size="small"
                helperText={
                  errorObj?.[field.fieldValue] &&
                  !formData?.[field.fieldValue] &&
                  `${field?.fieldName} is required`
                }
              />
            )}
          />
        </div>
      );
    } else if (field.fieldType == "file") {
      return (
        <div className="col-md-3 mt-2 mb-4 file_field">
          <TextField
            name="uploadfiles"
            className="inp_choose"
            type={field.fieldType}
            label={field.fieldName}
            inputProps={{
              multiple: true,
              style: { padding: "8.5px 14px" },
              accept: "image/*",
              capture: "environment",
            }}
            disabled={shiftStatus == 2 || prefilled.status == 2}
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(e) => {
              let files = Array.from(e.target.files);
              let compressedList = [];
              handleCompression(files).then((data) => {
                if (files && files.length > 0) {
                  let fileArray = data;
                  setFormData((prev) => ({
                    ...prev,
                    [`${field.fieldValue}file`]: fileArray,
                  }));
                  handleChange2(field.fieldValue, "dfshguyfds");
                  // console.log(files);
                }
              });
              // console.log(compressedList);
            }}
            error={
              errorObj?.[field.fieldValue] &&
              !formData?.[field.fieldValue + "file"]
            }
            helperText={
              errorObj?.[field.fieldValue] &&
              !formData?.[field.fieldValue + "file"] &&
              `${field?.fieldName} is required`
            }
          />
        </div>
      );
    } else if (field.fieldType == "radio") {
      return (
        <div className="col-md-3 col-12 radio-group">
          {field?.valueArr?.map((x, i) => {
            return (
              <>
                <label key={i}>
                  <input
                    type="radio"
                    name="status"
                    value={
                      formData[field.fieldValue] == x.value
                        ? "active"
                        : "inactive"
                    }
                    checked={formData[field.fieldValue] == x.value}
                    onChange={(e) => {
                      // setSelectedRadio(x.shiftId);
                      handleChange2(field.fieldValue, x.value);
                    }}
                  />
                  {x.name}
                </label>
              </>
            );
          })}
        </div>
      );
    }
  };

  const prefillField = (field) => {
    return;
  };

  // Example of a properly written async function
  const validateTripDetails1 = async (field) => {
    setLessThan("");
    setGreatThan("");
    setValidateRes(null);
    let formdata = {
      vehicleId: prefilled.vehicleId,
    };

    checkFields.forEach((x) => {
      if (x == field.fieldValue) {
        formdata[field.fieldValue] = formData[field.fieldValue];
      }
    });

    await validDateDetails(formdata).then((res) => {
      if (res.data?.statusDescription?.statusCode == 200) {
      } else if (res?.data?.statusDescription?.statusCode == 215) {
        setLessThan(res?.data?.statusDescription?.description);
        toast.warn(res?.data?.statusDescription?.description);
        let obj = res.data;
        delete obj["statusDescription"];

        setValidateField(field);

        setValidateRes(obj);
        setShowModal(true);
        return res.data;
      } else if (res?.data?.statusDescription?.statusCode == 210) {
        setGreatThan(res?.data?.statusDescription?.description);

        // toast.warn(res?.data?.statusDescription?.description);
        let obj = res.data;
        setGreatThan(res?.data?.statusDescription?.description);
        delete obj["statusDescription"];
        setValidateRes(obj);
        setShowModal(true);
        setValidateField(field);
        return res.data;
      }
    });
  };

  const addField = async () => {
    let errors = validateFields(formData, fieldsRequried);
    // console.log(errors);
    if (validateread?.length > 0) {
      validateTripDetails(validateread[0].field);
      return;
    }
    if (maxArray.length > 0) {
      let arr = [];
      let arr1 = [];

      maxArray.forEach((data) => {
        arr.push(data.fieldName);
        arr1.push(data.maxInput);
      });
      let obj = arr.join(",");
      let obj2 = arr1.join(",");

      toast.error(obj + " can't be more than " + obj2);
      return;
    }
    // if (errorObj) {

    //   return;
    // }

    if (
      formData?.startReading &&
      formData?.endReading &&
      Number(formData?.startReading) >= Number(formData?.endReading)
    ) {
      toast.warn("End reading should be greater than start reading");
      return;
    }

    if (
      formData?.kmOpening &&
      formData?.kmClosing &&
      Number(formData?.kmOpening) >= Number(formData?.kmClosing)
    ) {
      toast.warn("KM closing should be greater than KM opening");
      return;
    }
    if (errors == null || isEmpty(errors)) {
      exportAddition(formData, index);
    }
  };

  useEffect(() => {
    // // console.log(validateread);
    let arr = [...validateread];
    if (formData?.["reasonHour"]) {
      let arr1 = arr.filter((x) => {
        return x.field.fieldValue != "startReading";
      });
      // // console.log(arr1);
      setValidateRead(arr1);
    }

    if (formData?.["reasonKm"]) {
      let arr1 = arr.filter((x) => {
        return x.field.fieldValue != "kmOpening";
      });
      // // console.log(arr1);
      setValidateRead(arr1);
    }
  }, [
    formData?.["reasonKm"],
    formData?.["reasonHour"],
    formData?.["startReading"],
    formData?.["kmOpening"],
  ]);

  const validateTripDetails = async (field) => {
    setLessThan("");
    setGreatThan("");
    setValidateRes(null);
    let formdata = {
      vehicleId: prefilled.vehicleId,
    };

    checkFields.forEach((x) => {
      if (x == field.fieldValue) {
        formdata[field.fieldValue] = formData[field.fieldValue];
      }
    });

    await validDateDetails(formdata).then((res) => {
      if (res.data?.statusDescription?.statusCode == 200) {
      } else if (res?.data?.statusDescription?.statusCode == 215) {
        setLessThan(res?.data?.statusDescription?.description);
        // toast.warn(res?.data?.statusDescription?.description);
        let obj = res.data;
        let formdata = {
          field: field,
          msg: res?.data?.statusDescription?.description,
          validateRes: obj,
        };
        delete obj["statusDescription"];
        setValidateField(field);
        setValidateRes(obj);
        setShowModal(true);
        addValidRead(formdata);
      } else if (res?.data?.statusDescription?.statusCode == 210) {
        setGreatThan(res?.data?.statusDescription?.description);
        let obj = res.data;
        setGreatThan(res?.data?.statusDescription?.description);
        delete obj["statusDescription"];
        let formdata = {
          field: field,
          msg: res?.data?.statusDescription?.description,
          validateRes: obj,
        };
        setValidateRes(obj);
        setShowModal(true);
        setValidateField(field);
        addValidRead(formdata);
      }
    });
  };

  const addValidRead = (formdata) => {
    let arr = [...validateread];

    arr.push(formdata);
    // // console.log(arr);
    setValidateRead(arr);
  };

  const returnField = (validateField) => {
    return validateField?.fieldValue == "startReading"
      ? "reasonHour"
      : "reasonKm";
  };

  const isEmpty = (obj) => {
    return Object.keys(obj).length === 0;
  };

  const validateFields = (data, requiredFields) => {
    let errors = {};
    setErrorObj(null);
    requiredFields.forEach((field) => {
      if (field.isRequired == 1) {
        if (
          data[field.fieldValue] === null ||
          data[field.fieldValue] === undefined ||
          data[field.fieldValue] === ""
        ) {
          errors[field.fieldValue] = `${field.fieldName} is required`;
          // // console.log(errors);
        }
      }
    });
    // console.log(errors);
    setErrorObj(errors);
    return errors;
  };

  const validateFieldsMax = (value, data) => {
    let newErrors = {}; // copy existing errors, so you can update/remove them
    let maxArr = [...maxArray];

    console.log(
      maxArray.find((x) => {
        return x.fieldValue == data.fieldValue;
      })
    );
    console.log(maxArr);
    if (data.maxInput) {
      if (value > data.maxInput) {
        newErrors[
          data.fieldValue
        ] = `${data.fieldName} can't enter more than ${data.maxInput}`;

        if (
          !maxArray.find((x) => {
            return x.fieldName == data.fieldName;
          })
        ) {
          maxArr.push(data);
          setMaxArray(maxArr);
        }
      } else if (
        maxArray.find((x) => {
          return x.fieldName == data.fieldName;
        })
      ) {
        // If the value is valid, remove the error for this field
        delete newErrors[data.fieldValue];
        let arr = maxArr.filter((x) => {
          return x.fieldName != data.fieldName;
        });
        console.log(arr);
        setMaxArray(arr);
      }
    }
    console.log(maxArray);
    console.log(newErrors);
    setErrorObj(newErrors); // Update state
    return newErrors;
  };
  return (
    <>
      <div className="container mt-4">
        <form onSubmit={handleSubmit}>
          <div className="row">
            {prefillFields.map((field) => renderTextField(field))}

            {otherFields.map((field) => renderTextField(field))}
          </div>
          <div className="row d-flex justify-content-end mt-4">
            <hr />
            <div className="d-flex justify-content-end">
              <button
                className="btn yellow_btn_1 "
                type="button"
                onClick={(e) => {
                  addField();
                }}
              >
                {btnText ? btnText : "Submit"}
                {/* Submit */}
                {/* <i className="fa fa-plus " /> */}
              </button>
            </div>
          </div>
        </form>
      </div>

      <ConfimationModal
        show={showModal}
        onHide={() => {
          let obj = { ...errorObj };
          delete obj["reason"];
          // if (!onFoc) {
          //   document.getElementById(validateField.fieldValue + "id")?.focus();
          //   setOnFoc(true);
          // }
          setErrorObj(obj);
          setShowModal(false);
        }}
        size="md"
        btnTitle={"Save"}
        //Loading.
        onSubmit={() => {
          // // console.log(formData);
          if (
            formData[returnField(validateField)] === null ||
            formData[returnField(validateField)] === undefined ||
            formData[returnField(validateField)] === ""
          ) {
            setErrorObj({ [returnField(validateField)]: "Reason is required" });
            return;
          }
          setShowModal(false);
          let obj = { ...errorObj };
          delete obj["reason"];
          setErrorObj(obj);
          let obj1 = { ...formData, ...validateRes };
          // // console.log(obj1);
          setFormData(obj1);
          setShowModal(false);
        }}
        title="Reason Required"
      >
        <div className="container">
          <div className="row">
            {greatThan && <span>{greatThan}</span>}
            {lessThan && <span>{lessThan}</span>}
          </div>
          <div className="row mt-3">
            <div className="col-md-6">
              <TextField
                value={formData[returnField(validateField)]}
                name={returnField(validateField)}
                label="Reason"
                size="small"
                onChange={(e) => {
                  handleChange(e, {
                    fieldValue: returnField(validateField),
                  });
                }}
                error={
                  errorObj?.[returnField(validateField)] &&
                  !formData[returnField(validateField)]
                    ? errorObj[returnField(validateField)]
                    : null
                }
                helperText={
                  errorObj?.[returnField(validateField)] &&
                  !formData[returnField(validateField)]
                    ? errorObj[returnField(validateField)]
                    : null
                }
              />
            </div>
          </div>
        </div>
      </ConfimationModal>
    </>
  );
};

export default TripDetailsForm;
